import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { maybeGetSubscriptionForRegion } from "types/subscriptionType";

export const useIsUnlimitedSubscription = (): boolean => {
    const { region } = useMapViewRoutingMetadata();
    const user = useUserDataContext();

    // A team without a subscription in this region can't unlock buses at all,
    // which is the opposite of unlimited, so treat a missing subscription the
    // same way as a bus-limited one.
    return (
        maybeGetSubscriptionForRegion(user.subscriptions, region)?.unlimited ??
        false
    );
};
